import { API_URL } from "../config/connect";

const getAnnouncements = async (statusOrQuery, page = 1, limit = 10) => {
    let endpoint;
    if (typeof statusOrQuery === "string" && statusOrQuery.includes("=")) {
      endpoint = `${API_URL}/api/v1/admin/announcements?${statusOrQuery}`;
    } else {
      endpoint = `${API_URL}/api/v1/admin/announcements?status=${statusOrQuery}&page=${page}&limit=${limit}`;
    }
    const googleIdToken = localStorage.getItem("google_id_token");
    try {
        const response = await fetch(endpoint, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${googleIdToken}`,
                "Content-Type": "application/json",
            }
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('There was a problem fetching the announcements:', error);
        throw error;
    }
};

export default getAnnouncements;